import React, { useState, useRef, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'

import Paper from '@material-ui/core/Paper'
import { Grid } from '@material-ui/core'
import { TabPanel, TabContext, TabList } from '@material-ui/lab'
import { Tab } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@base/Inputs/Text'

import Title from '@base/Title'
import Toast from '@base/Toast'
import Loading from '@base/Loading'
import Filter from '@base/Filter'

import {
  DataGridDesempenho as RecebimentoEnvelope,
  DataGridDesempenho as LancamentoTriagens,
  DataGridDesempenho as CriacaoCaixas,
  DataGridDesempenho as CriacaoPendencias
} from '@pages/DesempenhoColaboradores/DataGridDesempenho'

import { ProcessoResolver } from "@helpers/ProcessoHelper"

import ColaboradorService from '@services/ColaboradorService'
import RelatorioService from '@services/RelatorioService'

export const DesempenhoColaboradores = () => {
  const processo = ProcessoResolver(useParams().processo);

  const [loading, setLoading] = useState(true);

  const [tab, setTab] = useState("0");
  const [data, setData] = useState([]);

  const [filtros, setFiltros] = useState([]);
  const [, setFiltroAtivo] = useState(false);
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);

  const [colaborador, setColaborador] = useState('');
  const [listagemColaboradores, setListagemColaboradores] = useState([]);

  const toastRef = useRef(null);

  const handleChange = (e, newTab) => {
    setTab(newTab);
  };

  const aplicarFiltros = (ativo = false) => {
    let f = [];

    if (colaborador) f.push({ field: 'colaborador', value: colaborador });

    setFiltros(f);
    setFiltroAtivo(ativo);
    setQuantidadeFiltrosAplicados(f.length);
  }

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparFiltros = () => {
    setFiltros([]);
    setFiltroAtivo(false);
    setColaborador('');
    setQuantidadeFiltrosAplicados(0);
  }

  const carregarDados = useCallback(() => {  
    if (listagemColaboradores.length === 0) {
      ColaboradorService.filtrar(processo.id, [{ field: 'processo', value: processo.id }, { field: 'size', value: 50 }])
        .then(resultado => {
          setListagemColaboradores(resultado.data.content.map(colaborador => {
            return {
              label: colaborador.sobrenome ? colaborador.nome + " " + colaborador.sobrenome : colaborador.nome,
              value: colaborador.id
            };
          }));
        })
        .catch(error => toastRef.current.show("error", "Ocorreu um Problema ao recuperar lista de Colaboradores para o Filtro."));
    } 

    RelatorioService.desempenhoPorData(processo.id, filtros)
      .then(res => setData(res.data))
      .catch(() => toastRef.current.show("error", "Não Foi Possivel Carregar a Listagem de Desempenho dos Colaboradores."))
      .finally(() => setLoading(false));
  }, [processo, filtros, listagemColaboradores]);

  useEffect(() => carregarDados(), [carregarDados]);

  return (
    <>
      <Toast ref={toastRef} />
      <Title>Desempenho dos Colaboradores</Title>

      <Filter
        handleFilter={aplicarFiltros}
        handleFilterClear={limparFiltros}
        countFilters={contarFiltrosAplicados}
      >
        <Grid item container spacing={4}>
          <Grid item sm={12} lg={4}>
            <Autocomplete
                id="colaborador"
                required
                name='colaborador'
                value={colaborador != null ? colaborador.label : null}
                onChange={(e, o) => { setColaborador(o != null ? o.value : null); }}
                options={listagemColaboradores}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => <TextField {...params} label='Colaborador' />}
                openText={`Abrir`}
                clearText={`Limpar`}
            />
          </Grid>
        </Grid>
      </Filter>

      <Grid item xs={12}>
        <Paper style={{ padding: '24px' }} elevation={0}>
          <TabContext value={tab}>
            <TabList onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
              <Tab label="Recebimento de Envelopes" value="0" />
              <Tab label="Lançamento de Triagens" value="1" />
              <Tab label="Criação de Caixas" value="2" />
              <Tab label="Criação de Pendências" value="3" />
            </TabList>

            {loading ?
              <Loading />
            :
              <>
                <TabPanel value="0">
                  <RecebimentoEnvelope data={data} field="recebimentosRealizados" />
                </TabPanel>
                <TabPanel value="1">
                  <LancamentoTriagens data={data} field="triagensRealizadas" />
                </TabPanel>
                <TabPanel value="2">
                  <CriacaoCaixas data={data} field="caixasCriadas" />
                </TabPanel>
                <TabPanel value="3">
                  <CriacaoPendencias data={data} field="pendenciasCriadas" />
                </TabPanel>
              </>
            }
          </TabContext>
        </Paper>
      </Grid>
    </>
  );
}

export default DesempenhoColaboradores;
